import React, { useState, useEffect } from "react";
import {
    Alert,
    Button,
    ButtonGroup,
    Container,
    Card,
    Col,
    Form,
    Row,
    Modal,
    Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";


import {
    getAuroraDivision,
    saveAuroraDivision,
    editAuroraDivision,
    deleteAuroraDivision

} from "../../redux/auroraDivision/actions";

import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import { Formik } from "formik";
import * as Yup from "yup";

const AuroraDivision = (props) => {
    const schema = Yup.object().shape({
        nombre: Yup.string().ensure().required("**Campo requerido"),
    });

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [edit, setEdit] = useState(false);
    const [index, setIndex] = useState(0);
    const [editItem, setEditItem] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [filter, setFilter] = useState("");
    //const [loadingType, setLoadingType] = useState('initial');
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);

    const dispatch = useDispatch();

    const {
        auroraDivision,
        auroraDivisionLength,
        loading,
        saveLoader,
        auroraDivisionError,
        formError,
    } = useSelector((store) => store.auroraDivision);
    const pages = Math.ceil(auroraDivisionLength / limit);

    const columns = [
        {
            Header: "Nombre",
            accessor: "nombre",
        },
        {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                <div className="btn-group" role="group">
                    <Button
                        size="sm"
                        variant="link"
                        type="button"
                        onClick={() => onEdit(value.row.original, value.row.index)}
                    >
                        <i className="material-icons">edit</i>
                    </Button>
                    <Button
                        size="sm"
                        className="text-danger"
                        variant="link"
                        type="button"
                        onClick={() => onDelete(value.row.original.id, value.row.index)}
                    >
                        <i className="material-icons">close</i>
                    </Button>
                </div>
            ),
        },
    ];

    // Métodos
    const getAAuroraDivision = (offs = offset, lim = limit, filt = filter) =>
        dispatch(
            getAuroraDivision(
                {
                    offset: offs,
                    limit: lim,
                    tipo_busqueda : "nombre",
                    filter: filt,
                }
            )
        );

    useEffect(() => getAAuroraDivision(), []);

    const onAdd = () => {
        setShowModal(true);
        setEdit(false);
        //setLoadingType('modal');
        setValidated(false);
    };

    const onEdit = (item, index) => {
        setIndex(index);
        setEdit(true);
        setEditItem(item);
        setShowModal(true);
        //setLoadingType('modal');
        setValidated(false);
    };

    const onSearch = (e) => {
        e.preventDefault();
        
        setFilter(e.target.filter.value);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getAAuroraDivision(oOffset, limit, e.target.filter.value);
    };

    const onSubmitAuroraDivision = (req) => {
        if (!edit) {
            dispatch(
                saveAuroraDivision(req,setShowModal)
            );
        } else {
            dispatch(
                editAuroraDivision(
                    req,
                    editItem.id,
                    index,
                    setShowModal
                )
            );
        }
    };

    const seeAll = () => {
        const oSearch = "";
        setFilter(oSearch);
        const oOffset = 0;
        setOffset(oOffset);
        setCurrentPage(1);
        getAAuroraDivision(oOffset, limit, oSearch);
    };

    const onDelete = (id, index) => {
        if (window.confirm(messages.preguntaEliminar)) {
            dispatch(
                deleteAuroraDivision(id, index)
            );
        }
    };

    const onShowSidebar = () => setShow(show ? false : true);

    return (
        <>
            <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
            <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
            <div className="custom-wrapper">
                <Container fluid>
                    <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                        <h6 className="font-weight-bold text-uppercase">
                            División Aurora
                            {parseInt(props.match.params.type) === 1 ? "Formal" : " Funcional"}
                        </h6>
                        <Form onSubmit={onSearch}>
                            <Row className="justify-content-end align-items-center flex-nowrap">

                                <Col xs="auto">
                                    <Form.Control
                                        name="filter"
                                        id="filter"
                                        placeholder="Buscar por nombre"
                                        className="rounded-pill form-control-sm"
                                        type="search"
                                    ></Form.Control>
                                </Col>
                                <Col xs="auto">
                                    <ButtonGroup>
                                        <Button
                                            onClick={() => seeAll()}
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle mr-1"
                                        >
                                            <i className="material-icons">list</i>
                                        </Button>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            className="rounded-circle"
                                            onClick={() => onAdd()}
                                        >
                                            <i className="material-icons">add</i>
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                            />
                        </div>
                    ) : (
                        auroraDivisionLength > 0 && (
                            <>
                                <Card className="border-0">
                                    <Card.Body className="px-1 px-sm-2">
                                        <CustomTable columns={columns} data={auroraDivision} />
                                    </Card.Body>
                                </Card>
                                <CustomPagint
                                    limit={limit}
                                    setLimit={setLimit}
                                    offset={offset}
                                    setOffset={setOffset}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    dataLenght={auroraDivisionLength}
                                    pages={pages}
                                    pagFunc={getAAuroraDivision}
                                />
                            </>
                        )
                    )}
                    {!loading &&
                        auroraDivisionLength === 0 &&
                        auroraDivisionError === "" && (
                            <Alert variant="info" className="my-4">
                                Aún no hay divisiones aurora, comienza agregando algunas
                            </Alert>
                        )}
                    {!loading && !!auroraDivisionError && (
                        <Alert variant="danger" className="my-4">
                            {auroraDivisionError}
                        </Alert>
                    )}
                </Container>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Formik
                    validationSchema={schema}
                    onSubmit={onSubmitAuroraDivision}
                    initialValues={{
                        nombre: edit ? editItem.nombre : null,
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => (
                        <Form onSubmit={handleSubmit} noValidate validated={validated}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    {edit ? "Editar División Aurora" : "Crear División Aurora"}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {!!formError && (
                                    <Alert variant="danger" className="my-1">
                                        {formError}
                                    </Alert>
                                )}
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column sm="12" md="4">
                                        Nombre
                                    </Form.Label>
                                    <Col sm="12" md="8">
                                        <Form.Control
                                            name="nombre"
                                            className="rounded-pill"
                                            type="text"
                                            value={values.nombre}
                                            onBlur={handleBlur("nombre")}
                                            onChange={handleChange}
                                            isInvalid={touched.nombre && !!errors.nombre}
                                            isValid={touched.nombre && !errors.nombre}
                                            placeholder="Nombre de la división aurora"
                                        ></Form.Control>
                                        {touched.nombre && errors.nombre && (
                                            <div>
                                                <small className="text-danger px-2">
                                                    {errors.nombre}
                                                </small>
                                            </div>
                                        )}

                                    </Col>
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    className="rounded-pill"
                                    variant="secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cerrar
                                </Button>
                                <Button
                                    className="rounded-pill"
                                    disabled={saveLoader}
                                    variant="primary"
                                    type="submit"
                                >
                                    {saveLoader && (
                                        <Spinner
                                            className="mr-2"
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    )}
                                    Guardar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
};

export default AuroraDivision;
